import {SelectButton} from './select-button';

const BOOLEAN_ANSWER_SELECT_BUTTONS_FR: SelectButton<boolean>[] = [
  {label: 'Oui', value: true},
  {label: 'Non', value: false},
];

const BOOLEAN_ANSWER_SELECT_BUTTONS_EN: SelectButton<boolean>[] = [
  {label: 'Yes', value: true},
  {label: 'No', value: false},
];

export const BOOLEAN_ANSWER_SELECT_BUTTONS = {
  en: BOOLEAN_ANSWER_SELECT_BUTTONS_EN,
  fr: BOOLEAN_ANSWER_SELECT_BUTTONS_FR,
};
